import { PropTypes } from 'prop-types';

const NoDataAvailable = ({ label }) => (
	<div className="alert-info alert mt-3">
		<i aria-hidden="true" className="ddc-icon ddc-icon-alert" />
		<div className="alert-content">{label}</div>
	</div>
);

NoDataAvailable.propTypes = {
	label: PropTypes.string.isRequired
};

export default NoDataAvailable;
